import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noEmailValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const emailRegExp: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const valid = emailRegExp.test(control.value);
        return valid ? {'noEmail': {value: control.value}} : null;
    }
}